import { Component, Input, OnInit } from '@angular/core';
import { Invite } from 'src/app/core/models/invite-model';
import { PagedList } from 'src/app/core/models/pagination';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss']
})
export class PaginationComponent implements OnInit {
  @Input() options: Options;
  @Input() pagedList: PagedList<Invite>;
  @Input() callback: (page?: number, itemsPerPage?: number)=> void;
  
  constructor() { }

  ngOnInit(): void {
  }

  next() {
    this.options.page++;
    this.callback(this.options.page, this.options.size);
  }

  prev() {
    this.options.page--;
    this.callback(this.options.page, this.options.size);
  }

  to(page: number) {
    this.options.page = page;
    this.callback(this.options.page, this.options.size);
  }
  get numbers(): number[] {
    return Array.from({ length: (this.pagedList != undefined && this.pagedList.pagination)?this.pagedList.pagination.totalPages:0 }, (_, i) => i + 1);
  }
}


export interface Options {
  size: number,
  page: number;
}
